import React, { useState } from "react";
import { Button, notification, Form, Input } from "antd";
import Screen from '../util/Extensions/Screens'
import RequestHandler from "../util/RequestHandler";
import LogoPic from '../assets/images/IsimIcinDefaultImage.png'
const ForgotPassword = (props) => {
  const [disabled, setDisabled] = useState(false);

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Şifre yenileme linkiniz mail adresinize gönderilmiştir.',
      duration: 2,
    });
  };

  const onFinishFailed = () => setDisabled(false);

  const onFinish = values => {
    setDisabled(true);
    RequestHandler.post(`/Auth/ForgotPassword`, {
      email: values.email,
      screenOption: Screen.screen
    }).then((response) => {
      if (response.success) {
        openNotificationWithIcon('success');
        setTimeout(function () {
          props.history.push('/');
        }.bind(this), 2000);
      }
    });
  };

  return (
    <div className="gx-login-container" style={{ background: "linear-gradient(330deg, rgba(226,213,242,1) 0%, rgba(255,255,255,1) 66%)" }}>
      <div className="gx-login-content ak-login">
        <div className="gx-login-header gx-text-center" >
          <h1 className="gx-login-title">
            <img src={LogoPic} alt='IsimIcin' style={{ width: '60%', marginTop: '5%' }} />

          </h1>
          <div className="gx-mb-4">
            <h1>Şifreni mi unuttun ?</h1>
            <h4 style={{ color: '#a8afb8' }}>Mail adresinizi yazdığnız takdirde</h4>
            <h4 style={{ color: '#a8afb8' }}>şifrenizi yenilemeniz için bir link gönderilecektir.</h4>
          </div>
          <Form
            initialValues={{ remember: true }}
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            className="gx-signin-form gx-form-row0">
            <Form.Item className="gx-text-center" name="email" rules={[{ required: true, message: 'Lütfen mail adresinizi girin!' }]}>
              <Input style={{ width: "75%", padding: 15 }} className='gx-input-lineheight' type="email" placeholder="Email adresinizi girin" />
            </Form.Item>
            <Form.Item>
              <Button style={{ backgroundColor: '#DC0005', color: 'white', margin: '5% 0', width: "75%", height: 54 }} htmlType="submit" disabled={disabled}>
                Gönder
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword
